/* eslint-disable eslint-comments/no-restricted-disable */
import type { EntryPoint, EntryPointComponent } from 'react-relay';
import type { OperationType } from 'relay-runtime';
import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

type CustomerConversationsAnalyticsAppEntryPointComponent = EntryPointComponent<
	Record<string, OperationType>,
	// oxlint-disable-next-line typescript/no-explicit-any
	Record<string, EntryPoint<any, any> | undefined>,
	{},
	{} | null
>;

export const customerConversationsAnalyticsAppEntryPoint: EntryPoint<
	CustomerConversationsAnalyticsAppEntryPointComponent,
	{}
> = createEntryPoint({
	root: JSResourceForInteraction<CustomerConversationsAnalyticsAppEntryPointComponent>(
		/* webpackChunkName: "async-help-center-settings-customer-conversations-analytics-app" */ './CustomerConversationsAnalyticsApp.tsx',
	),
	getPreloadProps: () => ({}),
});
